var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// import Button from '../button'
import filesize from 'filesize';
import * as React from 'react';
import Icon from '../icon';
import { Styled } from './style';
export var FileUploadProgressEnum;
(function (FileUploadProgressEnum) {
    FileUploadProgressEnum[FileUploadProgressEnum["IN_PROGRESS"] = 0] = "IN_PROGRESS";
    FileUploadProgressEnum[FileUploadProgressEnum["SUCCESS"] = 1] = "SUCCESS";
})(FileUploadProgressEnum || (FileUploadProgressEnum = {}));
var FileUploadProgress = /** @class */ (function (_super) {
    __extends(FileUploadProgress, _super);
    function FileUploadProgress(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { current_filesize: props.current_filesize ? props.current_filesize : 0 };
        return _this;
    }
    FileUploadProgress.getDerivedStateFromProps = function (nextProps, prevState) {
        return {
            current_filesize: nextProps.current_filesize ? nextProps.current_filesize : prevState.current_filesize,
        };
    };
    FileUploadProgress.prototype.render = function () {
        var _a = this.props, title = _a.title, mimetype = _a.mimetype, total_filesize = _a.total_filesize;
        var current_filesize = this.state.current_filesize;
        var iconName = 'document';
        if (mimetype && mimetype.startsWith('image')) {
            iconName = 'image';
        }
        else if (mimetype && mimetype.startsWith('video')) {
            iconName = 'video';
        }
        var uploadingFilesize = filesize(current_filesize, { round: 0 }) + ' / ';
        var uploadingPercent = Math.round(100 * (current_filesize / total_filesize));
        return (React.createElement(Styled, { className: "" + (this.props.status === FileUploadProgressEnum.IN_PROGRESS && current_filesize !== total_filesize
                ? 'file-in-progress'
                : '') },
            React.createElement(Icon, { name: iconName }),
            React.createElement("span", { className: "file-title" }, title),
            React.createElement("span", { className: "file-size" },
                uploadingFilesize,
                filesize(total_filesize, { round: 0 })),
            React.createElement("span", { className: "progress-bar", style: { width: uploadingPercent + "%" } })));
    };
    return FileUploadProgress;
}(React.Component));
export default FileUploadProgress;
//# sourceMappingURL=index.js.map